























import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { InvoicePaymentResourceModel } from '@/modules/invoice/models/invoice-reource.model'
import { Data } from '@/modules/shared/models/data'
import FinalPayment from '@/modules/transaction/components/shared/payment/FinalPayment.vue'
import BaseCart from '@/modules/common/cart/components/panel/BaseCart.vue'
import Vue from 'vue'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import {
  InvoiceGetPaymentResourceUseCase
} from '@/modules/invoice/use-cases/panel/invoice-get-payment-resource.use-case'
import { PanelInvoiceRoute } from '@/modules/invoice/routes/panel-invoice.route'
import { StartPaymentResource } from '@/modules/transaction/models/payment.model'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'پرداخت فاکتور',
    page_sub_header: 'از طریق یکی از روش های زیر می توانید اقدام به پرداخت نمایید'
  },
  metaInfo: {
    title: 'پرداخت فاکتور'
  },
  components: {
    BaseCart,
    FinalPayment
  }
})
export default class payment extends Vue {
  constructor(
    private readonly routes: PanelInvoiceRoute,
    private readonly useCase: InvoiceGetPaymentResourceUseCase
  ) {
    super()
  }

  @Prop() invoice!: Data<InvoicePaymentResourceModel>

  get payInfo() {
    return [
      {
        value: 'شماره',
        unit: this.invoice.data.id,
        column: 'پرداخت فاکتور'
      },
      {
        value: this.invoice.data.amount,
        unit: 'تومان',
        column: 'جمع کل'
      },
      {
        class: 'text-tes-red',
        value: this.invoice.data.discount || 0,
        unit: 'تومان',
        column: 'جمع تخفیف'
      },
      (this.invoice.data.tax || 0) > 0 && {
        value: this.invoice.data.tax,
        unit: 'تومان',
        column: 'مالیات'
      },
      {
        value: this.invoice.data.payable,
        unit: 'تومان',
        column: 'قابل پرداخت'
      }
    ].filter(Boolean)
  }

  async getPaymentResource(data): Promise<void | StartPaymentResource> {
    return this.useCase.execute(this.invoice.data.id, { ...data }).then(res => res)
  }

  get preInvoiceDownloadUrl() {
    return String(new URL(this.routes.download(this.invoice.data.id)))
  }
}
